export default {
  name: "UploadButton",
  functional: true,
  props: {
    btnStyle: {
      type: String,
      default: ""
    },
    button: {
      type: Object,
      default() {
        return {};
      }
    },
    owner: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  render(h, _vm) {
    const { props } = _vm;
    const { owner, button } = props;
    // return (
    //   <el-upload
    //     class="ds-button-update"
    //     style={_vm.data.style}
    //     disabled={props.button.disabled}
    //     headers={props.owner.getHeaders()}
    //     multiple={props.button.multiple}
    //     accept={props.owner.getFileAccept(props.button)}
    //     data={props.owner.getUploadData(props.button)}
    //     show-file-list={false}
    //     action={props.owner.uploadUrl(props.button)}
    //     on-progress={props.owner.handleProgress}
    //     on-change={props.owner.handleChange}
    //     on-success={() => {
    //       props.owner.handleAvatarSuccess(props.button);
    //     }}
    //     before-upload={props.owner.beforeAvatarUpload(props.button)}
    //   >

    //   </el-upload>
    // );
    return h(
      "el-upload",
      {
        class: "ds-button-update",
        style: _vm.data.style,
        props: {
          disabled: button.disabled,
          headers: owner.getHeaders(),
          multiple: button.multiple,
          accept: owner.getFileAccept(button),
          data: owner.getUploadData(button),
          showFileList: false,
          action: owner.uploadUrl(button),
          onProgress: owner.handleProgress,
          onChange: owner.handleChange,
          onSuccess: owner.handleAvatarSuccess(button),
          beforeUpload: owner.beforeAvatarUpload(button)
        }
      },
      [renderUploadButton(h, _vm)]
    );
  }
};

function renderUploadButton(h, _vm) {
  const { props } = _vm;
  const { owner, button } = props;
  return (
    <DsfButton
      icon={owner.getIcon(button)}
      title={button.title}
      disabled={button.disabled}
      size={owner.size}
      type={button.type}
      btn-style={props.btnStyle || button.btnStyle}
      icon-position={button.iconPosition}
      loading={button.loading}
      on-click={($event) => {
        owner.uploadClickBefore(button, $event);
        $event.stopPropagation();
      }}
    >
      {button.text}
    </DsfButton>
  );
}
